module.exports = __webpack_public_path__ + "img/5.5acdb7e8.jpg";